<template>
    <div>
    <b-toast :id="'notification_toast_'+item.event_id" solid no-auto-hide v-for="(item, idx) in items" :key="idx">
        <template #toast-title>
            <div class="px-0 mr-2">
                <div class="d-flex">
                    <i class="fa-regular fa-copy text-danger"></i>
                </div>

            </div>
            <div class="px-1 small">
                <div><span class="font-weight-bold">Cause:</span> {{ item.permissionName | titleCase }}</div>
                <div><span class="font-weight-bold">By:</span> {{ item.requestor_name }}</div>
                <div v-if="item.order_id"><span class="font-weight-bold">Order ID:</span> {{ item.order_id }}</div>
            </div>
        </template>
        <div class="text-left small">
            <span class="font-weight-bold">Override Message:</span><br>
            {{ item.permissionMessage }}
            <div v-if="item.description">
                <hr class="my-1">
                <span class="font-weight-bold">Description:</span><br>
                {{ item.description }}
            </div>
            <hr class="mb-0"/>
            <div>
                <b-button
                        v-b-tooltip.hover title="Accept Override"
                        class="float-right m-0 mt-1 mb-1"
                        @click="acceptItem(item, idx)"
                        size="sm" variant="success">
                    Accept
                </b-button>
                <b-button
                        v-b-tooltip.hover title="Decline Override"
                        class="float-right m-0 ml-1 mt-1 mb-1 mr-2"
                        @click="declineItem(item, idx)"
                        size="sm" variant="danger">
                    Reject
                </b-button>
            </div>
        </div>
    </b-toast>
    <AppHeaderDropdown right no-caret>
        <template slot="header">
            <i v-if="isBroadcastConnected" class="fa-regular fa-bell text-success"></i>
            <i v-else class="fa-regular fa-bell"></i>
            <b-badge v-if="all_items.length" pill variant="danger">{{ all_items.length }}</b-badge>
        </template>
        <template slot="dropdown">
            <b-dropdown-header class="text-center">
                <b-row align-v="center">
                    <b-col>
                <strong>You have {{ all_items.length }} notifications</strong>
                </b-col>
                <b-col md="auto">
                <b-button size="sm" variant="danger" :disabled="deletingAll" @click="removeAllItems" class="text-white">
                    <i v-if="deletingAll" class="fa-regular fa-spin fa-spinner fa-fw"></i>
                    <i v-else class="fa-regular fa-times fa-fw"></i>
                    Clear All
                </b-button>
                </b-col>
                </b-row>
            </b-dropdown-header>


            <!--Overrides-->
            <b-list-group>
                <b-list-group-item
                        class="px-3 py-2"
                        button
                        variant="secondary"
                        v-for="(item, idx) in items"
                        :key="idx"
                        :id="'notification_dropdown_c'+idx"
                        @click="goto(item)">

                        <div class="container">
                            <div class="row">
                                <div class="col px-0">
                                    <div class="d-flex align-items-center h-100">
                                        <i class="fa-regular fa-copy text-danger"></i>
                                    </div>

                                </div>
                                <div class="col-9 px-1 small">
                                    <div><span class="font-weight-bold">Cause:</span> {{ item.permissionName | titleCase }}</div>
                                    <div><span class="font-weight-bold">By:</span> {{ item.requestor_name }}</div>
                                    <div v-if="item.order_id"><span class="font-weight-bold">Order ID:</span> {{ item.order_id }}</div>
                                </div>

                                <div class="col px-1">
                                    <div class="d-flex align-items-center justify-content-end h-100">
                                        <b-button
                                                v-b-tooltip.hover title="Accept Override"
                                                class="float-right m-0"
                                                @click="acceptItem(item, idx)"
                                                size="sm" variant="secondary">
                                            <i class="fa-regular fa-check text-success"></i>
                                        </b-button>
                                        <b-button
                                                v-b-tooltip.hover title="Decline Override"
                                                class="float-right m-0 ml-1"
                                                @click="declineItem(item, idx)"
                                                size="sm" variant="secondary">
                                            <i class="fa-regular fa-times-circle text-danger"></i>
                                        </b-button>
                                    </div>

                                </div>
                            </div>
                        </div>

                    <b-tooltip noninteractive
                               placement="bottom"
                               variant="dark"
                               :target="'notification_dropdown_c'+idx">
                        <div class="text-left small">
                            <span class="font-weight-bold">Override Message:</span><br>
                            {{ item.permissionMessage }}
                            <div v-if="item.description">
                                <hr class="my-1">
                                <span class="font-weight-bold">Description:</span><br>
                                {{ item.description }}
                            </div>
                        </div>
                    </b-tooltip>
                </b-list-group-item>
            </b-list-group>



            <!--Flags & Documents-->
            <b-list-group>
                <b-list-group-item
                        class="px-3 py-2"
                        button
                        v-for="(item, idx) in flag_notifications"
                        :key="'flag'+idx"
                        :id="'flag_notification_dropdown_c'+idx">
                    <div class="container">
                        <div class="row" >
                            <div class="col px-0" @click="gotoOrder(item,idx)">
                                <div class="d-flex align-items-center h-100" >
                                    <i class="fa-regular fa-flag text-warning" v-if="item.type == 'flag'"></i>
                                    <i class="fa-regular fa-file text-info" v-else-if="item.type == 'document'"></i>
                                    <i class="fa-regular fa-file text-info" v-else-if="item.type == 'GoldExchange\\Models\\DocumentUpload'"></i>
                                </div>
                            </div>
                            <div class="col-10 px-1 small" @click="gotoOrder(item,idx)">
                                <div v-if="item.type == 'flag'">
                                    <span class="font-weight-bold">Flag: </span>{{item.name}} was <i>{{ item.status }}</i><br>
                                    <span class="font-weight-bold">Order ID: </span>#{{item.order_id}}
                                    <span class="float-right">{{ item.created_at | datetime }}</span>
                                </div>
                                <div v-else-if="item.type == 'document'">
                                    <span class="font-weight-bold">Document: </span>{{item.name}} was <i>Uploaded</i><br>
                                    <span class="font-weight-bold">Order ID: </span>#{{item.order_id}}
                                    <span class="float-right">{{ item.created_at | datetime }}</span>
                                </div>
                                <div v-else-if="item.type == 'GoldExchange\\Models\\DocumentUpload'">
                                    <span class="font-weight-bold">Document: </span>{{item.name}} was <i>Uploaded</i><br>
                                    <span class="font-weight-bold">Order ID: </span>#{{item.order_id}}
                                    <span class="float-right">{{ item.created_at | datetime }}</span>
                                </div>
                            </div>
                            <div class="col px-1">
                                <div class="d-flex align-items-center justify-content-end h-100">
                                    <b-button v-if="item.manual_clear"
                                              class="float-right m-0"
                                              v-b-tooltip.hover title="Delete Item"
                                              @click="deleteItem(item, idx)"
                                              size="sm"
                                              variant="secondary">
                                        <i class="fa-regular fa-trash text-danger"></i>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <b-tooltip
                            v-if="item.message"
                            placement="bottom"
                            noninteractive
                            variant="dark"
                            :target="'flag_notification_dropdown_c'+idx">
                        <div class="text-left small">
                            {{ item.message }}
                        </div>
                    </b-tooltip>
                </b-list-group-item>
            </b-list-group>

        </template>
    </AppHeaderDropdown>
    </div>
</template>

<script>
    import {HeaderDropdown as AppHeaderDropdown} from '@coreui/vue';
    import {
        BROADCAST_CONNECTED,
        NOTIFICATION_ADD,
        NOTIFICATION_REMOVE,
        SYNC_USER,
    } from '../store/actions';

    export default {
        name: 'NotificationList',
        data() {
            return {
                DEBUG_ADD: {},
                interval: null,
                flag_notifications: [],
                user_id: null,
                deletingAll: false,
            };
        },
        components: {
            AppHeaderDropdown,
        },
        computed: {
            isBroadcastConnected: function () {
                return this.$store.getters.isBroadcastConnected;
            },
            items: function () {
                return this.$store.getters.getNotifications;
            },
            all_items: function() {
                if (this.flag_notifications) {
                    return this.flag_notifications.concat(this.items);
                } else {
                    return [];
                }
            }
        },
        created() {
            this.doCleanup();
            this.interval = setInterval(()=>{this.doCleanup();}, 30000);
        },
        mounted() {
            console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
            if (! this.$store.getters.isBroadcastConnected) {
                this.$store.subscribe((mutation) => {
                    if (mutation.type === BROADCAST_CONNECTED) {
                        console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                        console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                        this.joinBroadcastChannel();
                    }
                });
            } else {
                console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
                this.joinBroadcastChannel();
            }
        },
        destroyed() {
            clearInterval(this.interval);
        },
        beforeDestroy() {

        },
        methods: {
            joinBroadcastChannel: function () {
                this.$store.dispatch(SYNC_USER, (profile) => {
                    this.user_id = profile.id;
                    this.$http.get('/users/' + profile.id + '/notifications').then((e) => {
                        this.flag_notifications = e.data.notifications;
                        let overrides = e.data.overrides;
                        for (let i = 0; i < overrides.length; i++) {
                            this.$store.dispatch(NOTIFICATION_ADD, overrides[i]);
                        }
                    });
                    console.info(String.fromCodePoint(0x1F514) + ' Joining App.User.' + profile.id + ' channel from HeaderDropdownNotifications.');
                    this.$echo.channel('App.User.' + profile.id)
                    .listen('PermissionRequestEvent', (notification) => {
                        console.log('NOTIFICATION FIRED', notification);
                        this.$store.dispatch(NOTIFICATION_ADD, notification);
                        this.playNotificationAlert();
                        this.$nextTick(()=> {
                            this.$bvToast.show('notification_toast_'+notification.event_id);
                        });
                    }).listen('UserNotificationCreated', (e) => {
                        if(e.notification.priority) {
                            this.flag_notifications.splice(0,0,e.notification);
                        }
                        else {
                            var i;
                            this.flag_notifications.splice(i, 0, e.notification);
                        }
                        this.$forceUpdate();
                        this.playNotificationAlert();
                    }).error((e) => {
                        console.log('ERROR OCCURRED', e);
                    });
                });
            },
            acceptItem: function(item, idx) {
                let send = {
                    'permissionName': item.permissionName,
                    'id': item.requestor_id,
                    'event_id': item.event_id,
                };
                this.$http.post('/users/acceptRequest', send);
                this.removeItem(idx);
            },
            declineItem: function(item, idx) {
                let send = {
                    'permissionName': item.permissionName,
                    'id': item.requestor_id,
                    'event_id': item.event_id,
                };
                this.$http.post('/users/declineRequest', send);
                this.removeItem(idx);
            },
            removeItem: function (idx) {
                this.$store.dispatch(NOTIFICATION_REMOVE, idx);
            },
            removeAllItems() {
                this.$bvModal.msgBoxConfirm('This action will clear all your notifications. Are you sure you want to continue?', {
                    titleHtml: '<i class="fa-regular fa-exclamation-triangle fa-2xl fa-fw text-danger"></i> Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Clear All',
                    cancelTitle: 'Cancel',
                    hideHeaderClose: false,
                    centered: true
                    })
                    .then((value) => {
                        if (value === true) {
                            this.deletingAll = true;
                            this.$http.delete('/users/' + this.user_id + '/notifications').then((response) => {
                                this.deletingAll = false;
                                this.flag_notifications = response.data.notifications;
                                let overrides = response.data.overrides;
                                for (let i = 0; i < overrides.length; i++) {
                                    this.$store.dispatch(NOTIFICATION_ADD, overrides[i]);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.deletingAll = false;
                    });

                
            },
            goto: function(item) {
                if(item.pageLink) {
                    this.$router.replace(item.pageLink);
                }
            },
            gotoOrder: function(item, idx) {
                if(item.order_id) {
                    this.$router.replace('/kit/view/' + item.order_id);
                }
                this.deleteItem(item,idx);
            },
            deleteItem(item, idx) {
                this.flag_notifications.splice(idx, 1);
                this.$http.delete('/users/notification/' + item.id);
            },
            doCleanup() {
                let currentTime = new Date().getTime();
                for(let i = this.items.lengchth - 1; i >= 0; i--) {
                    if(this.items[i].timeout < currentTime) {
                        this.removeItem(i);
                    }
                }
            },
            playNotificationAlert() {
                let audio = new Audio('/pop-up.mp3');
                audio.play();
            },
        },
        watch: {
            DEBUG_ADD(value) {
                if(value == 'remove') {
                    while(this.$store.getters.getNotifications.length > 0) {
                        this.removeItem(0);
                    }
                }
                this.$store.dispatch(NOTIFICATION_ADD, value, this);
            },
        },
    };
</script>

<style>
    .MainNotificationDropdown .dropdown-menu {
        width:400px !important;
        min-width:400px !important;
        max-height: 90vh;
        overflow: scroll;
    }
    .MainNotificationDropdown .b-dropdown-form {
        width:00px !important;
        min-width:400px !important;
        padding: 0;
    }
</style>
